<template>
  <div class="modal fade" id="reportGrantModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Report Grant</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h6 class="mb-4">
            Please let us know what is wrong with this grant.
          </h6>
          <form @submit.prevent="reportGrant">
            <div class="form-group">
              <label for="note">Reason for reporting</label>
              <textarea
                v-model="note"
                type="text"
                class="form-control"
                rows="3"
                id="note"
                placeholder="e.x. The grant says it is for classrooms, but it is only for entire schools."
                required
              />
            </div>
            <div class="mt-4">
              <button
                type="button"
                class="btn btn-outline-secondary"
                v-on:click="cancel()"
              >
                Cancel
              </button>
              <button type="submit" class="btn btn-outline-primary float-right">
                Report
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "ReportGrantModal",
  props: {
    GrantId: String
  },
  data() {
    return {
      note: "",
      grantId: this.GrantId
    };
  },
  watch: {
    GrantId: function() {
      this.grantId = this.GrantId;
    }
  },
  mounted() {
    $("#reportGrantModal").on("shown.bs.modal", function() {
      $("#note").focus();
    });
  },
  methods: {
    cancel() {
      $("#reportGrantModal").modal("hide");
      this.note = "";
    },
    async reportGrant() {
      var view = this;
      view.$store.commit("updateLoading", true);
      $("#reportGrantModal").modal("hide");
      try {
        const query = `
        mutation($grantId: Int!, $status: Int!) {
          UpdateGrantStatus(grantId: $grantId, status: $status) {
            Grant_Id
          }
        }`;
        const variables = {
          grantId: parseInt(view.grantId),
          status: 3
        };
        await view.$store.getters
          .fetcher({ query, variables })
          .then(async () => {
            const query = `
            mutation($grantId: Int!, $note: String!, $noteType: Int!, $writtenBy: Int!) {
              CreateGrantNote(grantId: $grantId, note: $note, grantNoteType: $noteType, writtenBy: $writtenBy) {
                Grant{
                  Grant_Id
                }
              }
            }`;
            const variables = {
              grantId: parseInt(view.grantId),
              note: view.note,
              noteType: 3,
              writtenBy: parseInt(view.$store.getters.user.User_Id)
            };
            await view.$store.getters.fetcher({ query, variables }).then(() => {
              view.$store.commit("updateLoading", false);
              view.$emit("reportedGrant", view.grantId);
            });
          });
      } catch (err) {
        console.log(err);
        $("#reportGrantModal").modal("show");
        view.$store.commit("updateLoading", false);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
